import React, {useCallback} from "react";
import classNames from "classnames";
import ReactGA from 'react-ga';

import {textMap} from "../common/Localization";

import './UpperHeader.scss';

const UpperHeader = () => {
	const sendGa = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"최상단-광고올리러가기"
		});
	}, []);
	
	return (
		<div id="upperHeader" className="bc_blue">
			<div className={classNames("header_wrap", "c_ff")}>
				<span className={classNames("badge", "c_blue", "cbc_light_blue", "t_12")}>{textMap.promotion_badge}</span>
				<span className={classNames("text", "t_14")}>{textMap.promotion_text}</span>
				<span className={classNames("link", "t_14")}>
					<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa}>
						{textMap.promotion_link}
						<img src={process.env.PUBLIC_URL + "/icon/arrow_right.png"} alt=""/>
					</a>
				</span>
			</div>
		</div>
	);
};

export default UpperHeader;
